import { useTheme } from "@/context/ThemeContext";
import DualPaneView from "../components/DualPaneView";
import { cardDataMap } from "../data";
import ExperienceShell from "../ExperienceShell";

export default function ShengxiaoExperiencePage() {
  const { effectiveTheme } = useTheme();

  return (
    <ExperienceShell activeId="shengxiao" contentKey="shengxiao">
      <DualPaneView data={cardDataMap.shengxiao} isLight={effectiveTheme === "light"} />
    </ExperienceShell>
  );
}
